import {entity} from "../rpc/api";
import SingleSkillTagList = entity.SingleSkillTagList;
import MultiSkillTagList = entity.MultiSkillTagList;
import OccupationSkillTagList = entity.OccupationSkillTagList;

class SingleSkillTagConvertResponse {

    public static from(from: entity.SingleSkillTag): SingleSkillTagConvertResponse {

        return new SingleSkillTagConvertResponse(
            from.id,
            from.name,
            from.category,
        )
    }

    constructor(
        public readonly id: string,
        public readonly name: string,
        public readonly category: entity.SingleSkillTag.Category
    ) {
    }

}

class MultiSkillTagConvertResponse {

    public static from(from: entity.MultiSkillTag): MultiSkillTagConvertResponse {

        return new MultiSkillTagConvertResponse(
            from.id,
            from.name,
            from.category,
        )
    }

    constructor(
        public readonly id: string,
        public readonly name: string,
        public readonly category: entity.MultiSkillTag.Category
    ) {
    }

}

class OccupationSkillTagConvertResponse {

    public static from(from: entity.OccupationSkillTag): OccupationSkillTagConvertResponse {

        return new OccupationSkillTagConvertResponse(
            from.id,
            from.parentID,
            from.name,
            from.category,
        )
    }

    constructor(
        public readonly id: string,
        public readonly parentID: string,
        public readonly name: string,
        public readonly category: entity.OccupationSkillTag.Category
    ) {
    }

}

class SingleSkillTagConvertResponseList {

    public static from(from: SingleSkillTagList): SingleSkillTagConvertResponseList {
        const items: SingleSkillTagConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(SingleSkillTagConvertResponse.from(item as entity.SingleSkillTag))
        });

        return new SingleSkillTagConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: SingleSkillTagConvertResponse[],
    ) {
    };

}

class MultiSkillTagConvertResponseList {

    public static from(from: MultiSkillTagList): MultiSkillTagConvertResponseList {
        const items: MultiSkillTagConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(MultiSkillTagConvertResponse.from(item as entity.MultiSkillTag))
        });

        return new MultiSkillTagConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: MultiSkillTagConvertResponse[],
    ) {
    };

}

class OccupationSkillTagConvertResponseList {

    public static from(from: OccupationSkillTagList): OccupationSkillTagConvertResponseList {
        const items: OccupationSkillTagConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(OccupationSkillTagConvertResponse.from(item as entity.OccupationSkillTag))
        });

        return new OccupationSkillTagConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: OccupationSkillTagConvertResponse[],
    ) {        
    };
}

export {
    SingleSkillTagConvertResponse,
    SingleSkillTagConvertResponseList,
    MultiSkillTagConvertResponse,
    MultiSkillTagConvertResponseList,
    OccupationSkillTagConvertResponse,
    OccupationSkillTagConvertResponseList,
}



// WEBPACK FOOTER //
// ./src/infra/api/service/skill_tag_api_convert.ts